import { StudentContractPageContent } from "@/pages/home/studentContracts/studentContract"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/home/contracten/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <StudentContractPageContent />
}
